<template>
  <div class="members">
    <div class="members_swiper">
      <div v-bind:style="{ 'background-image': 'url(' + background + ')', 'background-repeat': 'no-repeat', 'background-size': '100%', 'border-radius' : '15px' }">

      <slider animation="fade" :autoplay="false" :touch="false">
        <span v-for="(member, index) in members" v-bind:key="index">
          <slider-item>
            <div class="slider_item">
              <div class="slider_header">
                <div v-if="member.picture != null">
                  <img :src="member.picture" referrerpolicy="no-referrer" class="slider_header_image"/>
                </div>
              </div>
              <div class="slider_data">
                <div class="slider_member_name">

                  <div class="columns is-mobile">
                    <div class="column is-one-quarter" style="margin-top: 6px;">
                      <country-flag v-bind:country='member.country' size='big' rounded/>
                    </div>
                    <div class="column">
                      <div>
                        <h3 class="is-size-5">
                          {{ (member.display_name || member.name) }}
                        </h3>
                      </div>
                      <div>
                        <span class="slider_hometown">{{  member.home_town }}</span>
                      </div>
                    </div>
                  </div>                  

                  <div style="display: inline; float: left;">
                  </div>
                  <div style="display: inline; float: left;">
                  </div>
                </div>
                <div class="slider_member_details">
                  <h3 class="is-size-7"><span class="slider_member_details_label">Axe:</span> {{ member.axe }}</h3>
                  <h3 class="is-size-7"><span class="slider_member_details_label">Club:</span> {{ member.club }}</h3>
                  <h3 class="is-size-7"><span class="slider_member_details_label">Average:</span> {{ member.yearly_average }}</h3>
                  <h3 class="is-size-7"><span class="slider_member_details_label">Top 36'er:</span> {{ member.best_36 }}</h3>
                  <h3 class="is-size-7"><span class="slider_member_details_label">Consecutive Bulls:</span> {{ member.consecutive_bulls }}</h3>
                  <br/>
                  <h3 class="is-size-7"><span class="slider_member_bio_label">Bio:</span> {{ member.bio }}</h3>
                </div>
                <div class="slider_app_details">
                  <p><a href="https://topsailsoftware.ca" target="_blank">Topsail Software</a> &amp; <a href="https://www.wildaxe.com" target="_blank">Wild Axe</a> 2024</p>
                </div>
              </div>
            </div>
          </slider-item>
        </span>
      </slider>
    </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .axes2-background {
    margin-top: 30px;
    opacity: 40%; 
    position: absolute; 
  }
  .members {
    background-color: black;
    color: white;
    font-family: arial;
    width: 100%;
  }
  .members_swiper {
    padding-top: 10px;
    width: 350px;
    min-height: 700px;
    margin: auto;
  }
  .slider {
    height: 700px !important; /*override component*/
  }
  .slider_header {
    text-align: center;
    margin: auto;
    height: 200px; 
    margin-top: 10px;
  }
  .slider_header_image {
    width: 170px; 
    margin: auto;
    margin-top: 12px;
    border-radius: 10px;    
  }
  .slider_hometown {
    font-family: verdana; 
    color: white;
  }
  .slider_data {
    text-overflow: ellipsis;
  }
  .slider_item {
    height: 700px;
    /*background-color: #383838 !important;*/
    padding-left: 40px; 
    padding-right: 40px;    
  }
  .slider_member_details {
    height: 290px;
  }
  .slider_member_name {
    height: 115px;
    color: goldenrod !important;
    font-family: '28 Days Later';   
    white-space: nowrap; //this prevents line breaks.
    overflow: hidden; //this hides text that doesnt fit within the div.
    text-overflow: ellipsis; 
  }
  .slider_member_bio_label {
    font-weight: bold;
    font-size: 1.2em;
  }
  .slider_member_details_label {
    font-weight: bold;
  }
  .slider_app_details {
    height: 18px;
    font-size: 0.7em;
    color: black;
    background-color: rgb(104, 103, 103);
    text-align: center;
  }
  .slider_app_details a {
    color: black;
    text-decoration: none;
  }
</style>

<script>
import { Slider, SliderItem } from 'vue-easy-slider'
import CountryFlag from 'vue-country-flag';
import axios from 'axios' 

export default {
name: 'members',
  components: {
    Slider,
    SliderItem,
    CountryFlag
  },
  computed: {
  },
  data () {
      return {
        members: [],
        debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
        publicPath: process.env.BASE_URL,
        background: process.env.BASE_URL + 'img/member_background.png'
      }
  },
  methods:{
    isAdmin() {
      return this.$parent.isAdmin();
    },
    getMembersPublicProfiles() {
      var url = (this.debugMode ? "http://localhost:8080/members/" : "https://axes2api.azurewebsites.net/members/")
      var token = this.$parent.getApiToken();
      axios.get(url,{
        headers: {
          authorization: token
        }
      })
      .then((response) => {
        response.data.forEach(element => {
          if (element.bio != null && element.bio.length > 250) {
            element.bio = element.bio.substring(0,250);
          }
        });
        this.members = response.data;
      }, (error) => {
        alert(error);
      });
    }
  },
  mounted(){
    this.getMembersPublicProfiles();
  }
}
</script>
